module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('h2', [_vm._v("Список курсов")]), _vm._v(" "), _c('ext-table', {
    attrs: {
      "fields": {
        name: {
          label: 'Название'
        },
        cost: {
          label: 'Стоимость'
        },
        shedule: {
          label: 'Расписание'
        },
        period: {
          label: 'Период'
        }
      },
      "loadProxy": {
        url: 'api/course',
        method: 'get'
      },
      "deleteProxy": {
        url: 'api/course/' + _vm.selectedCourseId,
        method: 'delete'
      }
    },
    on: {
      "select": function (id) {
        _vm.selectedCourseId = id
      }
    }
  }, [_c('template', {
    slot: "createForm"
  }, [_c('course-form', {
    attrs: {
      "submitProxy": {
        url: 'api/course',
        method: 'put'
      }
    }
  })], 1), _vm._v(" "), _c('template', {
    slot: "updateForm"
  }, [_c('course-form', {
    attrs: {
      "submitProxy": {
        url: 'api/course/' + _vm.selectedCourseId,
        method: 'post'
      },
      "loadProxy": {
        url: 'api/course/' + _vm.selectedCourseId,
        method: 'get'
      }
    }
  })], 1)], 2)], 1)]), _vm._v(" "), _c('hr', {
    staticClass: "my-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('h2', [_vm._v("Модули курса")]), _vm._v(" "), _c('ext-table', {
    attrs: {
      "fields": {
        name: {
          label: 'Название'
        },
        period: {
          label: 'Период'
        },
      },
      "deleteProxy": {
        url: 'api/course/' + _vm.selectedCourseId,
        method: 'delete'
      }
    },
    on: {
      "select": function (id) {
        _vm.selectedCourseId = id
      }
    }
  }, [_c('template', {
    slot: "createForm"
  }, [_c('course-form', {
    attrs: {
      "submitProxy": {
        url: 'api/course',
        method: 'put'
      }
    }
  })], 1), _vm._v(" "), _c('template', {
    slot: "updateForm"
  }, [_c('course-form', {
    attrs: {
      "submitProxy": {
        url: 'api/course/' + _vm.selectedCourseId,
        method: 'post'
      },
      "loadProxy": {
        url: 'api/course/' + _vm.selectedCourseId,
        method: 'get'
      }
    }
  })], 1)], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('h2', [_vm._v("Таблица оплаты")]), _vm._v(" "), _c('ext-table', {
    attrs: {
      "fields": {
        paymentPeriod: {
          label: 'Сроки оплаты'
        },
        month: {
          label: 'За месяц'
        },
        cost: {
          label: 'Сумма'
        }
      },
      "deleteProxy": {
        url: 'api/course/' + _vm.selectedCourseId,
        method: 'delete'
      }
    },
    on: {
      "select": function (id) {
        _vm.selectedCourseId = id
      }
    }
  }, [_c('template', {
    slot: "createForm"
  }), _vm._v(" "), _c('template', {
    slot: "updateForm"
  })], 2)], 1)]), _vm._v(" "), _c('hr', {
    staticClass: "my-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('h2', [_vm._v("Материалы к курсам")]), _vm._v(" "), _c('ext-table', {
    attrs: {
      "fields": {
        name: {
          label: 'Название'
        },
        type: {
          label: 'Тип'
        }
      },
      "deleteProxy": {
        url: 'api/course/' + _vm.selectedCourseId,
        method: 'delete'
      }
    },
    on: {
      "select": function (id) {
        _vm.selectedCourseId = id
      }
    }
  }, [_c('template', {
    slot: "createForm"
  }), _vm._v(" "), _c('template', {
    slot: "updateForm"
  })], 2)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c3c695b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/CourseManage.vue
// module id = 227
// module chunks = 1